import {
  SVG,
} from 'web-styled';

import * as S from './styled';

type Props = {
  src?: string | null,
  className?: string,
  placeholderSize?: number | string,
  placeholderColor?: string,
} & S.WrapProps;

const Avatar = ({
  src,
  width = '130px',
  height = '130px',
  bgColor,
  className,
  borderWidth = 0,
  borderColor = '#ffffff',
  placeholderSize = 18,
  placeholderColor = '#fff',
}: Props) => (
  <S.AvatarWrapper
    width={width}
    height={height}
    bgColor={bgColor}
    className={className}
    borderWidth={borderWidth}
    borderColor={borderColor}
  >
    {src ? (
      <S.Avatar
        style={{
          backgroundImage: `url(${src})`,
        }}
      />
    ) : (
      <SVG.Avatar
        width={placeholderSize}
        fill={placeholderColor}
      />
    )}
  </S.AvatarWrapper>
);

export default Avatar;
